import React, { useCallback } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import {  HandlingLayout} from '../Layout';

function HandlingTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
     const handleHandlingFormLoad = useCallback(() => {
        props.handlingFormLookupsLoad();
    }, []);

    const handleSelectionChange = useCallback((name, value,e) => {
        props.handleHandlingFieldChange(name, value);
    }, []);
    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='EE75A080-9641-4E9A-A3D5-A0E1314247E6'
                layoutName='WMItemDataEntryStatusForm'
                defaultFormSchema={HandlingLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleHandlingFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(HandlingTab);
